
import { List, ListBody, ListWrapper } from '../../../BTUI/List';
import PanelLayout from '../../panelComponents/PanelLayout/PanelLayout';
import './style.css';
import { useEffect, useState } from 'react';
import authService from '../../../service/auth';

const TemplateList = () => {
    const [templatesList, setTemplatesList] = useState([]);

    useEffect(()=>{
        authService?.templatesList()
            .then((res) => {
                console.log("list",res);
                setTemplatesList(res?.data?.response?.tempList)
            })
            .catch((err) => {
                console.log("list",err);
            });
    },[])

    return<PanelLayout>
        {/* <Center> */}
            {/* <Button varient="action-btn" bgColor="primary" title={`Add New Template`} onClick={()=>navigate('/executive/template/add')}/> */}
        {/* </Center> */}
        <br/>
        <ListWrapper style={{maxWidth:'1200px',margin:'auto'}}>
            <List thead={Thead} title="Templates" actionBtnTitle="Add New Template" href="/executive/template/add">
                <ListBody>
                    {templatesList?.length>0 ? templatesList?.map((template,index) => {
                        return <tr key={index}>
                            <td>{index+1}</td>
                            <td>{template?.code}</td>
                            <td>{template?.title}</td>
                            <td>{template?.description}</td>
                            <td style={{display: 'flex'}}>
                                {/* <Button title={<IoIosEye />} varient="icon" onClick={()=>navigate('/executive/taxfile/'+template?.id)} /> */}
                                {/* <Button title={<RiDeleteBin6Line />} varient="icon" onClick={()=>navigate('/executive/taxfile/'+template?.id)} /> */}
                                {/* <Button title={<RiDeleteBin6Line />} varient="icon" onClick={()=>alert('delete')} /> */}
                            </td>
                        </tr>
                    }): <p style={{textAlign: 'center', marginTop: '20px'}}>No Record Found</p>}
                </ListBody>
            </List>
        </ListWrapper>
    </PanelLayout>
}

export default TemplateList;

const Thead = [
    {
        title: 'Sr. No',
        width: '5%'
    },
    {
        title: 'Code',
        width: '10%'
    },
    {
        title: 'Title',
        width: '15%'
    },
    {
        title: 'Description',
        width: '60%'
    },
    {
        title: 'Action',
        width: '10%'
    },
]